import * as React from 'react';
import { ClickTracker } from 'bernie-analytics';
import { UitkButtonSize, UitkPrimaryButton } from 'uitk-react-button';
import { UitkScrim, UitkScrimType } from 'uitk-react-scrim';
import { DoubleLink } from 'components/common/media/double-link';
import { LoyaltyEducation } from 'models/common/loyalty-education';
import { LoyaltyEducationContent } from './loyalty-education-content';

const LinkTracked = ClickTracker(DoubleLink);

interface LoyaltyEducationDialogContentProps {
  loyaltyEducation?: LoyaltyEducation;
}

export const LoyaltyEducationDialogContent: React.FunctionComponent<LoyaltyEducationDialogContentProps> = ({ loyaltyEducation }) => {
  if (!loyaltyEducation) {
    return null;
  }

  const { title, content, action } = loyaltyEducation;

  return (
    <React.Fragment>
      {title && <h1 className="uitk-type-heading-600 uitk-type-bold all-y-margin-four">{title}</h1>}
      {content && (
        <section>
          <LoyaltyEducationContent type={content._type} content={content} />
        </section>
      )}

      {action &&
        action.text && (
          <UitkScrim type={UitkScrimType.BUTTON}>
            <LinkTracked to={action.href} rfrr={action.rfrr} linkName="Rewards Dialog Button">
              <UitkPrimaryButton
                id="join-rewards-btn"
                text={action.text}
                data-stid="join-rewards-btn"
                isFullWidth={true}
                size={UitkButtonSize.LARGE}
              />
            </LinkTracked>
          </UitkScrim>
        )}
    </React.Fragment>
  );
};
